// Shared, null-safe display formatters. A null / undefined / non-finite value renders as an em
// dash ("—") instead of "NaN", "$NaN", or throwing — so a missing evidence field degrades
// gracefully rather than blanking a card. Counts use locale grouping; percent takes a ratio.

const DASH = '—';

function bad(n: number | null | undefined): boolean {
  return n == null || !Number.isFinite(n);
}

/** Integer/count with locale grouping. count(16746) → "16,746". */
export function count(n: number | null | undefined): string {
  return bad(n) ? DASH : (n as number).toLocaleString();
}

/** Ratio (0–1) or multiplier → percent. pct(0.93) → "93%", pct(4.61) → "461%". */
export function pct(ratio: number | null | undefined, decimals = 0): string {
  return bad(ratio) ? DASH : `${((ratio as number) * 100).toFixed(decimals)}%`;
}

/** Whole-dollar currency. usd(1130) → "$1,130"; usd(50, {perDay:true}) → "$50/day". */
export function usd(n: number | null | undefined, opts: { perDay?: boolean } = {}): string {
  if (bad(n)) return DASH;
  return `$${(n as number).toLocaleString(undefined, { maximumFractionDigits: 0 })}${opts.perDay ? '/day' : ''}`;
}

/** Currency with cents, for small targets like tCPA. usdCents(9) → "$9.00". */
export function usdCents(n: number | null | undefined): string {
  return bad(n) ? DASH : `$${(n as number).toFixed(2)}`;
}
